import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Assessment from "./sections/Assessment";
import Location from "./sections/Location";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <Assessment />
      <Location />
      <Contact />
      <Footer />
    </div>;
}